<template>
  <h3> {{ $t('reports.otherPaymentsTitle') }}</h3>
  <ui-grid>
    <ui-grid-cell columns="2">
      <ui-form-field>
        <ui-checkbox v-model="filtrarPorEvento" input-id="checkbox"></ui-checkbox>
        <label for="checkbox">{{ $t('reports.filterEvent') }}</label>
      </ui-form-field>
    </ui-grid-cell>
    <ui-grid-cell columns="2">
      <ui-textfield outlined fullwidth v-model="criterioBusquedaEvento" :disabled="!filtrarPorEvento"
        @keyup.enter="buscar">{{ $t('commonElements.event') }}</ui-textfield>
    </ui-grid-cell>
    <ui-grid-cell columns="2">
      <ui-form-field>
        <ui-checkbox v-model="filtrarPorTipo" input-id="checkboxT"></ui-checkbox>
        <label for="checkboxT">{{ $t('reports.filterRegistry') }}</label>
      </ui-form-field>
    </ui-grid-cell>
    <ui-grid-cell columns="2">
      <ui-textfield outlined fullwidth v-model="criterioBusquedaTipo" :disabled="!filtrarPorTipo" @keyup.enter="buscar">
        {{ $t('commonElements.registry') }}</ui-textfield>
    </ui-grid-cell>
    <ui-grid-cell columns="1">
      <ui-icon-button icon="search" @click="buscar"> </ui-icon-button>
    </ui-grid-cell>
    <ui-grid-cell columns="1">
      <ui-icon-button icon="undo" @click="undo"> </ui-icon-button>
    </ui-grid-cell>
    <ui-grid-cell columns="1">
      <ui-icon-button icon="refresh" @click="updateTickets"> </ui-icon-button>
    </ui-grid-cell>
    <ui-grid-cell columns="1">
      <ui-icon-button icon="sim_card_download" @click="downloadReport"> </ui-icon-button>
    </ui-grid-cell>
  </ui-grid>
  <ui-progress v-show="fileDownloading" indeterminate active></ui-progress>
  <error-component v-show="errorLoad" :message="errorMessage" />
  <ui-table fullwidth :data="filteredRegistries" :thead="thead" :tbody="tbody" :tfoot="tfoot">
  </ui-table>
</template>
<script>
import { helpers } from "balm-ui";
import { useMainStore } from '@/stores/main';
import { mapState } from 'pinia';
import PaymentsAPI from "@/api/PaymentsAPI";
import ErrorComponent from "@/components/common/ErrorComponent.vue";
import formatters from "@/utils/formatters";

export default {
  name: "TablaReporteRegistros",
  components: {
    ErrorComponent
  },
  props: {
    registriesReport: Array,
  },
  emits: ["refreshReportRegistries"],
  computed: {
    ...mapState(useMainStore, ['userLogged']),
  },
  data() {
    return {
      thead: [
        this.$t('reports.eventName'),
        this.$t('reports.registrationTypeQty'),
        {
          value: this.$t('commonElements.netMXN'),
          align: "right",
          sort: "none",
          columnId: "totalSold",
        },
      ],
      tbody: [
        "eventName",
        "registerType",
        {
          field: "totalSold",
          fn: (data) => {
            return formatters.formatCurrency(data.totalSold);
          },
          align: "right",
        },
      ],
      tfoot: [
        null,
        null,
        {
          field: "totalSold",
          fnName: "sum",
          fn: (data) => {
            return formatters.formatCurrency(data);
          },
          align: "right",
        },
      ],
      filtrarPorEvento: false,
      filtrarPorTipo: false,
      filteredRegistries: [...this.registriesReport],
      criterioBusquedaEvento: "",
      criterioBusquedaTipo: "",
      errorLoad: false,
      fileDownloading: false,
      errorMessage: ""
    };
  },
  methods: {
    updateTickets() {
      this.$emit("refreshReportRegistries");
    },
    undo() {
      this.filteredRegistries = [...this.registriesReport];
      this.criterioBusquedaEvento = "";
      this.criterioBusquedaTipo = "";
      this.filtrarPorEvento = false;
      this.filtrarPorTipo = false;
      this.page = 1;
    },
    buscar() {
      if (this.filtrarPorEvento && this.filtrarPorTipo) {
        if (
          !helpers.isEmpty(
            this.criterioBusquedaEvento.trim() &&
            !helpers.isEmpty(this.criterioBusquedaTipo.trim())
          )
        ) {
          this.filteredRegistries = [...this.registriesReport].filter(
            (report) =>
              report.eventName.includes(this.criterioBusquedaEvento) &&
              report.registerType.includes(this.criterioBusquedaTipo)
          );
        }
      } else if (
        this.filtrarPorEvento &&
        !helpers.isEmpty(this.criterioBusquedaEvento.trim())
      ) {
        this.filteredRegistries = [...this.registriesReport].filter((report) =>
          report.eventName.includes(this.criterioBusquedaEvento)
        );
      } else if (
        this.filtrarPorTipo &&
        !helpers.isEmpty(this.criterioBusquedaTipo.trim())
      ) {
        this.filteredRegistries = [...this.registriesReport].filter((report) =>
          report.registerType.includes(this.criterioBusquedaTipo)
        );
      }
    },
    async downloadReport() {
      try {

        this.fileDownloading = true;
        let fileName = "pagos_complementarios_" + new Date().toLocaleDateString() + ".xlsx"

        const paymentsApi = new PaymentsAPI();

        const fileData = await paymentsApi.downloadRegistriesReport({
          token: this.userLogged.token,
        });
        const link = document.createElement('a')
        link.href = URL.createObjectURL(fileData)
        link.target = "_blank"
        link.download = fileName
        link.click()
        URL.revokeObjectURL(link.href)
        this.fileDownloading = false;

      } catch (error) {
        this.errorLoad = true;
        this.fileDownloading = false;
        this.errorMessage = error;
      }
    }
  },
};
</script>
<style scoped>
h3 {
  text-align: center;
  margin-top: 2em;
}
</style>